import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; 
import { Provider } from 'react-redux';
import { SidebarProvider } from './context/SidebarContext';
import { ThemeProvider } from './components//ThemeSwitchContext';
import ThemedSuspense from './components/ThemedSuspense';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import {store} from './app/store'

const root = ReactDOM.createRoot(document.getElementById('root'));
 
root.render(
  <Provider store={store}>
  <SidebarProvider>
    <ThemeProvider>
    <Suspense fallback={<ThemedSuspense />}> 
        <App /> 
    </Suspense>
    </ThemeProvider>
  </SidebarProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register()

